import { Table, TableColumnType } from "antd";
import React, { useMemo } from "react";
import { OrderItem } from "../../../../model/OrderItem";
import { OrderItemProductOptionInfo } from "../../../../model/Reservation/Options";
import OrderItemStatusBadge from "../../../../pages/ReservationDetail/components/OrderItemStatusBadge";
import ReturnStatusText from "../../../../pages/ReservationDetail/components/ReturnStatusText";
import { ProductStatusType } from "../Expended/Products/ProductStatus";
import { CustomCard } from "./Card.styled";
import { CustomTable } from "./Table.styeld";

interface ProductInfoProps {
  dataSource: (OrderItem | OrderItemProductOptionInfo)[];
  type: ProductStatusType;
}

/**
 * 상품정보
 * @param param0
 * @returns
 */
export const ProductInfo: React.FC<ProductInfoProps> = ({
  dataSource,
  type = "TIRE",
}) => {
  /**
   * 타이어 컬럼
   */
  const tireColumns: TableColumnType<any>[] = [
    { title: "분류", dataIndex: "category", key: "category", width: "10%" },
    {
      title: "모델명",
      dataIndex: "orderItemModelNo",
      key: "orderItemModelNo",
      width: "30%",
    },
    {
      title: "상품명",
      dataIndex: "orderItemName",
      key: "orderItemName",
      width: "30%",
    },
    {
      title: "수량",
      dataIndex: "orderItemAmount",
      key: "orderItemAmount",
      align: "right",
      width: "10%",
    },
    {
      title: "상품상태",
      dataIndex: "orderItemStatus",
      key: "orderItemStatus",
      align: "center",
      width: "10%",
      render: (value) => (
        <div style={{ display: "inline-flex" }}>
          <OrderItemStatusBadge status={value} />
        </div>
      ),
    },
    {
      title: "반품상태",
      dataIndex: "orderItemReturnStatus",
      key: "orderItemReturnStatus",
      align: "center",
      width: "10%",
      render: (value) => (
        <div style={{ display: "inline-flex" }}>
          <ReturnStatusText status={value} />
        </div>
      ),
    },
  ];

  /**
   * 엔진오일 컬럼
   */
  const engineoilColumns: TableColumnType<any>[] = [
    {
      title: "분류",
      dataIndex: "productOptionName",
      key: "productOptionName",
      width: "10%",
    },
    {
      title: "상품명",
      dataIndex: "productOptionValue",
      key: "productOptionValue",
      width: "40%",
    },
    { title: "부품번호", dataIndex: "erpCode", key: "erpCode", width: "20%" },
    {
      title: "수량",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: "10%",
    },
    {
      title: "상품상태",
      dataIndex: "orderItemStatus",
      key: "orderItemStatus",
      align: "center",
      width: "10%",
      render: (value) => (
        <div style={{ display: "inline-flex" }}>
          <OrderItemStatusBadge status={value} />
        </div>
      ),
    },
    {
      title: "반품상태",
      dataIndex: "orderItemReturnStatus",
      key: "orderItemReturnStatus",
      align: "center",
      width: "10%",
      render: (value) => (
        <div style={{ display: "inline-flex" }}>
          <ReturnStatusText status={value} />
        </div>
      ),
    },
  ];

  const columns = useMemo(
    () => (type === "ENGINE_OIL" ? engineoilColumns : tireColumns),
    [type]
  );

  return (
    <CustomCard bodyStyle={{ padding: 0, overflow: "hidden" }}>
      <CustomTable
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </CustomCard>
  );
};
